import { useMemo, useState } from 'react';
import type { JSX, ReactNode } from 'react';

export function SearchablePickList<T extends { id: string }>({
  legend,
  items,
  queryPlaceholder,
  testId,
  filter,
  renderItem,
}: {
  legend: string;
  items: readonly T[];
  queryPlaceholder: string;
  testId: string;
  filter: (item: T, query: string) => boolean;
  renderItem: (item: T) => ReactNode;
}): JSX.Element {
  const [query, setQuery] = useState('');
  const visible = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return items;
    return items.filter((item) => filter(item, needle));
  }, [filter, items, query]);

  return (
    <fieldset className="fieldset" data-testid={testId}>
      <legend>{legend}</legend>
      <label className="field">
        Search
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder={queryPlaceholder}
          data-testid={`${testId}-search`}
        />
      </label>
      {visible.length === 0 ? <p className="meta">No matches.</p> : null}
      {visible.map((item) => (
        <div key={item.id}>{renderItem(item)}</div>
      ))}
    </fieldset>
  );
}
